/**
 * The pounds↔pence edge for the WS9 pricing editor. Money is integer pence everywhere inside the app
 * and across the wire; the £ text input is a display convenience, so conversion happens ONLY here at
 * the form boundary (mirrors the helpers in ServiceModal). Never do price arithmetic past this edge —
 * resolved/derived prices come from the API (the shown==charged honesty rule).
 */

/** "1400" (pence) → "14.00" for a £ input; null → "". */
export function penceToPounds(pence: number | null | undefined): string {
  if (pence == null) return '';
  return (pence / 100).toFixed(2);
}

/** "14" | "14.5" | "£14.00" → 1400 pence; returns null if not a valid non-negative amount. */
export function poundsToPence(input: string): number | null {
  const cleaned = input.replace(/[£,\s]/g, '');
  if (!cleaned) return null;
  const value = Number(cleaned);
  if (!Number.isFinite(value) || value < 0) return null;
  return Math.round(value * 100);
}
